import React from "react";

export default function RenderInput({ onlyImage, onChange, inputRef }) {
  return (
    <input
      ref={inputRef}
      type="file"
      onChange={(e) => {
        const file = e.target.files[0];

        if (file) {
          const fs = new FileReader();
          fs.onload = () => {
            onChange({
              uri: fs.result,
              file,
            });
          };
          fs.readAsDataURL(file);
        }
        e.target.value = "";
      }}
      style={{ display: "none" }}
      accept={onlyImage ? "image/*" : ""}
    />
  );
}
